import { render, staticRenderFns } from "./OnDemandTrainingErrorModal.vue?vue&type=template&id=797955a0"
import script from "./OnDemandTrainingErrorModal.vue?vue&type=script&lang=js"
export * from "./OnDemandTrainingErrorModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports